import type { Subject } from 'services/api';
import type { PageableResponse } from '../types';
import type { SubjectsListRequest } from './types';
import { api } from '../api';

export const subjectsApi = api.injectEndpoints({
  endpoints: (build) => ({
    getSubjects: build.query<PageableResponse<Subject>, SubjectsListRequest>({
      query: (params = {}) => ({
        url: '/subjects',
        params: {
          ...params,
        },
      }),
      keepUnusedDataFor: 30,
    }),
  }),
});

export const { useGetSubjectsQuery } = subjectsApi;
